import {
  assignVersionToList,
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../common_components/mdae-framework";
import { cloneDeep } from "lodash";
import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_COMPLETED_AND_CANCELED_MY_TASKS } from "../services/get-completed-and-canceled-my-tasks";

export const SET_MY_TASKS_COMPLETED_AND_CANCELED_TAB_DATA =
  "SET_MY_TASKS_COMPLETED_AND_CANCELED_TAB_DATA";
export const SET_SELECTED_MY_TASKS_TAB_DATA = "SET_SELECTED_MY_TASKS_TAB_DATA";
const initialError = {
  code: "",
  message: "",
  value: [],
};
export const defaultCompletedAndCanceledTabData = {
  isIncludeCanceledTasks: false,
  canceledTaskMonthRange: 3,
  isIncludeCompletedTasks: true,
  completedTaskMonthRange: 3,
};

const initialState = {
  loading: false,
  error: initialError,
  completedAndCanceledTabData: defaultCompletedAndCanceledTabData,
  isActiveTaksTabSelcted: true,
  isCompletedAndCanceledTaksTabSelcted: false,
  completedAndCanceledTaskList: [],
  isCompletedAndCanceledTasksListLoading: true
};
export default (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_COMPLETED_AND_CANCELED_MY_TASKS)(action)) {
        return {
          ...state,
          isCompletedAndCanceledTasksListLoading: true
        };
      }
      if (isAsyncComplete(GET_COMPLETED_AND_CANCELED_MY_TASKS)(action)) {
        const response = action.response;
        return {
          ...state,
          completedAndCanceledTaskList: assignVersionToList(response.myTaskList),
          isCompletedAndCanceledTasksListLoading: false,
          completedAndCanceledTabData: {
            ...state.completedAndCanceledTabData,
            isCompletedChecked:
              state.completedAndCanceledTabData.isIncludeCompletedTasks,
            isCanceledChecked:
              state.completedAndCanceledTabData.isIncludeCanceledTasks,
          },
        };
      }
      return state;
    case SET_MY_TASKS_COMPLETED_AND_CANCELED_TAB_DATA:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const completedAndCanceledTabData = newState.completedAndCanceledTabData
          ? newState.completedAndCanceledTabData
          : {};
        for (let prop in action.data.completedAndCanceledTabData) {
          completedAndCanceledTabData[prop] =
            action.data.completedAndCanceledTabData[prop];
        }
        newState = {
          ...newState,
          completedAndCanceledTabData,
        };
      }
      return newState;
    case SET_SELECTED_MY_TASKS_TAB_DATA:
      return { ...state, ...action.data };
    default:
      return state;
  }
};
